export interface Comic {
  id: string;
  title: string;
  category: 'fantasy' | 'campus' | 'romance';
  categoryName: string;
  tags: string[];
  description: string;
  cover: string;
  status: '连载中' | '已完结';
  chapters: number;
  rating: number;
  views: string;
  author: string;
  updateTime: string;
  isFeatured: boolean;
}

export interface CategoryMeta {
  key: 'fantasy' | 'campus' | 'romance';
  name: string;
  short: string;
  tagline: string;
  desc: string;
  color: string;
  cover: string;
}

export const categories: CategoryMeta[] = [
  {
    key: 'fantasy',
    name: '奇幻漫画',
    short: '奇幻',
    tagline: '穿越异界 · 龙与魔法 · 热血冒险',
    desc: '从异世界重生到古龙契约，奇幻韩漫用天马行空的想象带你踏上热血冒险之旅。魔法、地下城、神秘种族一应俱全，世界观宏大，追更停不下来。',
    color: 'primary',
    cover: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20landscape%20with%20floating%20islands%20and%20a%20dragon%20flying%20under%20a%20golden%20sunset%20sky%2C%20vibrant%20korean%20webtoon%20manhwa%20art%20style%2C%20warm%20magical%20glow%2C%20cinematic%20wide%20illustration&width=640&height=480&seq=fantasy-cat-01&orientation=landscape',
  },
  {
    key: 'campus',
    name: '校园漫画',
    short: '校园',
    tagline: '青春同窗 · 社团热血 · 成长故事',
    desc: '教室、社团与毕业季，校园韩漫定格青春最鲜活的瞬间。友情、梦想与微妙的心动交织，清新治愈又热血，是很多人入坑韩漫的第一站。',
    color: 'accent',
    cover: 'https://readdy.ai/api/search-image?query=sunny%20high%20school%20campus%20with%20cherry%20blossoms%20and%20students%20in%20uniforms%2C%20bright%20fresh%20day%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20soft%20warm%20daylight%2C%20wide%20illustration&width=640&height=480&seq=campus-cat-01&orientation=landscape',
  },
  {
    key: 'romance',
    name: '恋爱漫画',
    short: '恋爱',
    tagline: '心动信号 · 双向暗恋 · 甜甜日常',
    desc: '怦然心动的瞬间、命中注定的重逢，恋爱韩漫把最甜的心跳画给你看。双向暗恋、校园初恋、都市轻喜剧，每个故事都在治愈你的心。',
    color: 'secondary',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20pastel%20illustration%20with%20two%20silhouettes%20and%20floating%20hearts%20and%20soft%20bokeh%20lights%2C%20sweet%20korean%20webtoon%20manhwa%20art%20style%2C%20warm%20cozy%20tones%2C%20wide%20illustration&width=640&height=480&seq=romance-cat-01&orientation=landscape',
  },
];

export const comics: Comic[] = [
  {
    id: 'rebirth-otherworld',
    title: '异界重生录',
    category: 'fantasy',
    categoryName: '奇幻漫画',
    tags: ['异世界', '重生', '冒险'],
    description: '平凡少年意外陨落，却在异世界带着前世记忆重生。觉醒隐藏职业后，他一步步踏上征服王座的热血征途。',
    cover: 'https://readdy.ai/api/search-image?query=young%20brave%20swordsman%20holding%20a%20glowing%20sword%20standing%20in%20a%20fantasy%20world%20with%20floating%20islands%20and%20warm%20sunset%20sky%2C%20determined%20expression%2C%20vibrant%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20warm%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-01&orientation=portrait',
    status: '连载中',
    chapters: 328,
    rating: 9.2,
    views: '3.6亿',
    author: '墨风',
    updateTime: '2026-08-17',
    isFeatured: true,
  },
  {
    id: 'dragon-contract',
    title: '龙之契约',
    category: 'fantasy',
    categoryName: '奇幻漫画',
    tags: ['龙族', '契约', '热血'],
    description: '落魄驭龙师少女与最后一头古龙缔结契约，一人一龙从互相戒备到生死相托，掀起惊天动地的冒险传奇。',
    cover: 'https://readdy.ai/api/search-image?query=a%20girl%20dragon%20rider%20and%20a%20majestic%20golden%20dragon%20bonding%20on%20a%20cliff%20at%20sunrise%2C%20epic%20and%20heroic%2C%20vibrant%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20warm%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-02&orientation=portrait',
    status: '连载中',
    chapters: 156,
    rating: 9.0,
    views: '2.1亿',
    author: '青崖',
    updateTime: '2026-08-18',
    isFeatured: true,
  },
  {
    id: 'magic-academy-story',
    title: '魔法学院物语',
    category: 'fantasy',
    categoryName: '奇幻漫画',
    tags: ['学院', '魔法', '成长'],
    description: '天赋平平的菜鸟法师误入顶级魔法学院，在爆笑与热血中一步步成为独当一面的魔法师。',
    cover: 'https://readdy.ai/api/search-image?query=cheerful%20young%20wizard%20apprentice%20casting%20a%20spell%20with%20a%20magic%20staff%20and%20sparkles%20in%20a%20magical%20academy%2C%20vibrant%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20warm%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-03&orientation=portrait',
    status: '连载中',
    chapters: 210,
    rating: 8.8,
    views: '1.4亿',
    author: '南瓜汤',
    updateTime: '2026-08-16',
    isFeatured: false,
  },
  {
    id: 'abyss-echo',
    title: '深渊回响',
    category: 'fantasy',
    categoryName: '奇幻漫画',
    tags: ['地下城', '冒险', '悬疑'],
    description: '一支由边缘人组成的冒险小队，闯入传闻中的深渊地下城。越是深入，越发现这座迷城藏着足以颠覆世界的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=adventurer%20party%20with%20torches%20entering%20a%20mysterious%20ancient%20underground%20dungeon%20ruin%2C%20moody%20but%20vibrant%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-04&orientation=portrait',
    status: '已完结',
    chapters: 188,
    rating: 9.1,
    views: '2.8亿',
    author: '夜行',
    updateTime: '2026-07-30',
    isFeatured: true,
  },
  {
    id: 'star-hunter',
    title: '星穹猎手',
    category: 'fantasy',
    categoryName: '奇幻漫画',
    tags: ['星际', '科幻', '冒险'],
    description: '宇宙赏金猎人与神秘星舰少女结伴同行，穿梭星系破解古老文明遗迹的终极谜题。',
    cover: 'https://readdy.ai/api/search-image?query=cool%20young%20space%20bounty%20hunter%20and%20a%20girl%20standing%20before%20a%20nebulae%20filled%20starry%20sky%20with%20a%20starship%2C%20vibrant%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-05&orientation=portrait',
    status: '连载中',
    chapters: 92,
    rating: 8.7,
    views: '8600万',
    author: '银河旅人',
    updateTime: '2026-08-15',
    isFeatured: false,
  },
  {
    id: 'youth-classmates',
    title: '青春同班生',
    category: 'campus',
    categoryName: '校园漫画',
    tags: ['日常', '友情', '治愈'],
    description: '一群性格迥异的高中生在同一个班级里笑闹成长，把最平凡也最闪亮的青春日常画给你看。',
    cover: 'https://readdy.ai/api/search-image?query=happy%20group%20of%20high%20school%20students%20in%20uniforms%20chatting%20in%20a%20bright%20classroom%2C%20warm%20daylight%2C%20youthful%20and%20fresh%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-06&orientation=portrait',
    status: '连载中',
    chapters: 240,
    rating: 9.0,
    views: '2.4亿',
    author: '小满',
    updateTime: '2026-08-18',
    isFeatured: true,
  },
  {
    id: 'transfer-student-arrives',
    title: '转学生来了',
    category: 'campus',
    categoryName: '校园漫画',
    tags: ['转校生', '校园', '青春'],
    description: '神秘转学生的到来打破了平静的校园，一场关于友情、秘密与成长的青春物语就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=shy%20transfer%20student%20holding%20books%20with%20a%20backpack%20entering%20a%20sunny%20school%20corridor%2C%20fresh%20and%20youthful%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-07&orientation=portrait',
    status: '连载中',
    chapters: 132,
    rating: 8.6,
    views: '9700万',
    author: '半糖',
    updateTime: '2026-08-14',
    isFeatured: false,
  },
  {
    id: 'club-wars',
    title: '社团风云',
    category: 'campus',
    categoryName: '校园漫画',
    tags: ['社团', '热血', '竞技'],
    description: '濒临解散的冷门社团发起逆袭，少年们在一次次对决与并肩作战中找回属于青春的冲劲。',
    cover: 'https://readdy.ai/api/search-image?query=passionate%20high%20school%20students%20practicing%20sports%20and%20club%20activities%20on%20a%20sunny%20campus%20field%2C%20energetic%20and%20dynamic%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-08&orientation=portrait',
    status: '连载中',
    chapters: 178,
    rating: 8.9,
    views: '1.3亿',
    author: '燃点',
    updateTime: '2026-08-13',
    isFeatured: false,
  },
  {
    id: 'before-graduation',
    title: '毕业之前',
    category: 'campus',
    categoryName: '校园漫画',
    tags: ['毕业季', '青春', '感动'],
    description: '高考倒计时三百天，少年们在题海与球场之间拼命奔跑，只为不留遗憾地说一声再见。',
    cover: 'https://readdy.ai/api/search-image?query=high%20school%20students%20studying%20together%20by%20a%20window%20with%20cherry%20blossom%20petals%20outside%2C%20nostalgic%20and%20warm%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-09&orientation=portrait',
    status: '已完结',
    chapters: 96,
    rating: 9.3,
    views: '1.9亿',
    author: '晚风',
    updateTime: '2026-06-28',
    isFeatured: false,
  },
  {
    id: 'secrets-in-classroom',
    title: '教室里的秘密',
    category: 'campus',
    categoryName: '校园漫画',
    tags: ['悬疑', '校园', '反转'],
    description: '转校第一天就卷入神秘事件的少年，在层层反转中一点点揭开藏在这间教室背后的真相。',
    cover: 'https://readdy.ai/api/search-image?query=a%20curious%20high%20school%20boy%20peeking%20into%20a%20dim%20mysterious%20classroom%20with%20papers%20scattered%2C%20suspenseful%20and%20moody%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-10&orientation=portrait',
    status: '连载中',
    chapters: 76,
    rating: 8.5,
    views: '5200万',
    author: '灰雾',
    updateTime: '2026-08-12',
    isFeatured: false,
  },
  {
    id: 'heartbeat-signal',
    title: '心动信号',
    category: 'romance',
    categoryName: '恋爱漫画',
    tags: ['双向暗恋', '甜宠', '校园'],
    description: '学霸与死党在无数次眼神交汇中疯狂心动，双向暗恋的酸涩与甜蜜都被画成了粉红色泡泡。',
    cover: 'https://readdy.ai/api/search-image?query=cute%20teenage%20couple%20blushing%20with%20a%20glowing%20heart%20symbol%20between%20them%2C%20pastel%20pink%20warm%20tones%2C%20sweet%20romance%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-11&orientation=portrait',
    status: '连载中',
    chapters: 210,
    rating: 9.2,
    views: '3.2亿',
    author: '奶糖',
    updateTime: '2026-08-18',
    isFeatured: true,
  },
  {
    id: 'seatmate-you',
    title: '邻座的你',
    category: 'romance',
    categoryName: '恋爱漫画',
    tags: ['同桌', '初恋', '校园'],
    description: '高中同桌之间从互看不顺眼到悄悄心动，一段又甜又真实的青春初恋慢慢发芽。',
    cover: 'https://readdy.ai/api/search-image?query=two%20high%20school%20deskmates%20stealing%20shy%20glances%20at%20each%20other%20in%20a%20classroom%2C%20tender%20and%20sweet%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-12&orientation=portrait',
    status: '连载中',
    chapters: 168,
    rating: 8.9,
    views: '2.0亿',
    author: '柚子茶',
    updateTime: '2026-08-16',
    isFeatured: false,
  },
  {
    id: 'first-love-memo',
    title: '初恋备忘录',
    category: 'romance',
    categoryName: '恋爱漫画',
    tags: ['重逢', '都市', '治愈'],
    description: '多年后与初恋在咖啡馆重逢，尘封的回忆被一点点翻开，这一次他们不想再错过彼此。',
    cover: 'https://readdy.ai/api/search-image?query=a%20young%20woman%20and%20man%20meeting%20again%20in%20a%20cozy%20cafe%20with%20soft%20warm%20lighting%2C%20gentle%20and%20romantic%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-13&orientation=portrait',
    status: '已完结',
    chapters: 124,
    rating: 9.0,
    views: '1.7亿',
    author: '绵云',
    updateTime: '2026-07-20',
    isFeatured: false,
  },
  {
    id: 'love-theater',
    title: '恋爱剧场',
    category: 'romance',
    categoryName: '恋爱漫画',
    tags: ['都市', '轻喜剧', '甜宠'],
    description: '脑洞清奇的都市轻喜剧，一对欢喜冤家在啼笑皆非的日常里闹出无数粉红笑料。',
    cover: 'https://readdy.ai/api/search-image?query=cheerful%20urban%20couple%20having%20fun%20together%20with%20coffee%20and%20bokeh%20city%20night%20lights%2C%20light%20romantic%20comedy%20vibe%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-14&orientation=portrait',
    status: '连载中',
    chapters: 146,
    rating: 8.8,
    views: '1.2亿',
    author: '可乐桶',
    updateTime: '2026-08-17',
    isFeatured: true,
  },
  {
    id: 'running-together',
    title: '双向奔赴',
    category: 'romance',
    categoryName: '恋爱漫画',
    tags: ['治愈', '成长', '校园'],
    description: '两个习惯把心事藏起来的少年少女，在一次偶然合作中学会坦诚，最终奔向彼此。',
    cover: 'https://readdy.ai/api/search-image?query=two%20shy%20high%20school%20students%20running%20toward%20each%20other%20under%20a%20golden%20afternoon%20sun%2C%20warm%20hopeful%20tone%2C%20korean%20webtoon%20manhwa%20art%20style%2C%20clean%20background%2C%20portrait%20cover%20art&width=480&height=640&seq=cover-15&orientation=portrait',
    status: '已完结',
    chapters: 88,
    rating: 9.1,
    views: '1.1亿',
    author: '南巷',
    updateTime: '2026-07-05',
    isFeatured: false,
  },
];

export const heroImage =
  'https://readdy.ai/api/search-image?query=vibrant%20collage%20of%20korean%20manhwa%20webtoon%20characters%20in%20a%20fantasy%20city%20with%20a%20dragon%2C%20cherry%20blossoms%20and%20magical%20sparkles%2C%20colorful%20energetic%20wide%20banner%20illustration%2C%20slightly%20dark%20at%20edges%20for%20text%20overlay%2C%20rich%20warm%20and%20teal%20tones&width=1600&height=900&seq=hero-2026-01&orientation=landscape';